module.exports = __WEBPACK_EXTERNAL_MODULE_207__;


//////////////////
// WEBPACK FOOTER
// external "text-encoding-utf-8"
// module id = 207
// module chunks = 0